"use client";

import { usePageContext } from "@repo/ui/contexts/PageContext";
import type { NormalizedFlightSections } from "@repo/ui/features/flights/helpers/normalizeFlightPageSections";
import type { FlightPageContent } from "@repo/ui/types/cms/flight";

export default function AllInclusivePricingMessage() {
  const { normalizedSections } = usePageContext<FlightPageContent, NormalizedFlightSections>();
  const { flightLabels } = normalizedSections;

  return (
    <div className="mb-3 w-full px-4 py-1" data-testid="all-inclusive-pricing-message">
      <div
        className="text-center text-sm text-brand-blue [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-brand-turquoise"
        dangerouslySetInnerHTML={{
          __html: flightLabels.priceDisclaimer,
        }}
      />
    </div>
  );
}
